<script setup lang="ts">
import CurrentAlmIcon from "@/components/CurrentAlmIcon/CurrentAlmIcon.vue";

import FlowStickyChip from "./FlowStickyChip.vue";

defineProps<{ text: string; link: string }>();
</script>

<template>
  <FlowStickyChip class="alm-chip" :tooltip-text="text" name="alm-link">
    <a :href="link" target="_blank" class="link">
      <CurrentAlmIcon class="icon" />
      <span class="text">{{ text }}</span>
    </a>
  </FlowStickyChip>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";
@use "@/styles/mixins/typography";
@use "@/styles/font";

.alm-chip {
  padding: 3px 4px;
  flex-shrink: 0;

  .link {
    @include typography.extra-small;

    // Chrome ignores the `draggable="false"` attribute on links and always starts a
    // native link-drag, which hijacks the SortableJS card drag on the kanban board.
    // `-webkit-user-drag: none` is the only thing Chrome honors here.
    -webkit-user-drag: none;
    font-weight: font.$weight-semi-bold;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    height: 20px;
    text-decoration: none;

    .icon {
      height: 14px;
      max-height: 14px;
    }
  }
}
</style>
